import { HttpClient, HttpMethods } from "@planzone/services";

function resetChatMemory(httpClient: HttpClient) {
  return (conversationId: string) =>
    httpClient
      .sendHttpRequest({
        endpoint: `/secured/memory/${conversationId}`,
        method: HttpMethods.DELETE,
      })
      .then(() => Promise.resolve());
}

export { resetChatMemory };
